const locale = {
  FILTER_SCRIPT_FORECASE: 'Script Forecast',
  BUTTON_PRINT_REQUEST: 'Print Request',
  BUTTON_APPLY: 'Apply',
  TABLE_HEADER_FIRST_NAME: 'First Name',
  TABLE_HEADER_LAST_NAME: 'Last Name',
  TABLE_HEADER_MEDICATION: 'Medication',
  TABLE_HEADER_DIRECTION: 'Direction',
  TABLE_HEADER_CURRENT_BALANCE: 'Current Balance',
  TABLE_HEADER_REPEAT_REMAINING: 'Repeats Remaining',
  TABLE_HEADER_PATIENT_GROUP: 'Patient Group',
  TABLE_HEADER_DOCTOR: 'Doctor',
  TABLE_HEADER_LAST_DISPENSE_IMPORT: 'Last Dispense Import',
  BUTTON_SEND_REQUEST: 'Send Request',
  BUTTON_EMAIL_REQUEST: 'Email',
  EMAIL_REQUEST_SUCCESS: 'Script Request successfully emailed to Doctor',
  EMAIL_REQUEST_FAIL: 'Failed to send email to doctor',
  EMAIL_NO_SELECTION_TITLE: 'Cannot send email',
  EMAIL_NO_SELECTION_MESSAGE: 'Please select at least one script before sending email.',
  EMAIL_DOCTOR_MISSING_TITLE: 'Cannot send email',
  EMAIL_DOCTOR_MISSING_INTRO: 'The following doctor(s) do not have an email address:',
  EMAIL_NO_ELIGIBLE_SCRIPTS: 'No valid scripts found for email.',
  FILTER_INCLUDE_VPB: 'Include VPB',
  PLACE_HOLDER_DRUG_STATUS: 'All Drug Status',
  LABEL_SELECTED_DRUG_STATUS: 'Selected Drug Status',
  FILTER_WEEK_NUMBER: 'Week Number',
  PLACE_HOLDER_DRUG: 'Drug',
  LABEL_DRUG: 'Drug',
  TABLE_HEADER_DRUG: 'Drug',
  TABLE_HEADER_DATE_MODIFIED: 'Date Requested',
  TABLE_HEADER_REPORT: 'Report',
  TABLE_HEADER_USER: 'User',
  BUTTON_SEARCH: 'Search',
  BUTTON_LOG: 'Log',
  FROM_DATE: 'From',
  TO_DATE: 'To',
  SEARCH_LOG: 'Search',
  DRUG_LABEL: 'Drug',
};

export default locale;
